export default __webpack_public_path__ + "static/media/logobg.d736d3a8.png";